<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'des-relatorio-km-automatico') {
            next({ name: 'des-relatorio-km-automatico-list' });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == 'des-relatorio-km-automatico') {
            this.$router.push({ name: 'des-relatorio-km-automatico-list' });
        }
    },
};
</script>
